import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = await login(email, password);
      toast.success(`Welcome back, ${user.name.split(" ")[0]}.`);
      navigate(user.role === "admin" ? "/admin" : "/discover");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] flex items-center justify-center px-4 texture-grain">
      <div className="card-surface w-full max-w-md p-8" data-testid="login-form">
        <p className="eyebrow mb-2">Welcome back</p>
        <h1 className="font-display text-3xl text-stone-900 mb-6">Log in to Veritas40+</h1>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-sm font-medium text-stone-700 block mb-1.5">Email</label>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full rounded-xl border border-[#E7DFD5] bg-white px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1F3A34]/30"
              placeholder="you@example.com"
              data-testid="login-email-input"
            />
          </div>
          <div>
            <label className="text-sm font-medium text-stone-700 block mb-1.5">Password</label>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full rounded-xl border border-[#E7DFD5] bg-white px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-[#1F3A34]/30"
              placeholder="••••••••"
              data-testid="login-password-input"
            />
          </div>
          {error && (
            <p className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-xl px-4 py-2.5" data-testid="login-error-message">
              {error}
            </p>
          )}
          <button type="submit" disabled={busy} className="btn-primary w-full" data-testid="login-form-submit-button">
            {busy ? "Logging in…" : "Log in"}
          </button>
        </form>
        <p className="mt-6 text-sm text-stone-500 text-center">
          New to Veritas40+?{" "}
          <Link to="/register" className="text-[#C58342] font-medium hover:underline" data-testid="login-register-link">
            Create your account
          </Link>
        </p>
      </div>
    </div>
  );
}
